import { History } from "history";

import {
  GET_SUBSCRIPTION_REPORT,
  GET_SUBSCRIPTION_REPORT_ERROR,
  GET_SUBSCRIPTION_REPORT_SUCCESS,
  GetSubscriptionReportAction,
  GetSubscriptionReportErrorAction,
  GetSubscriptionReportSuccessAction,
  RESET_SUBSCRIPTION_REPORT,
  ResetSubscriptionReportAction,
} from "./actionTypes";
import {
  ParentsWithActiveChildSubscription,
  ParentsWithoutActiveChildSubscription,
  StudentsWithActiveSubscription,
  StudentsWithoutActiveSubscription,
  SubscriptionReportRequest,
} from "../../interfaces/reports";

//#region Subscription Report

export const getSubscriptionReport = (
  request: SubscriptionReportRequest
): GetSubscriptionReportAction => {
  return {
    type: GET_SUBSCRIPTION_REPORT,
    payload: { request },
  };
};

export const getSubscriptionReportSuccess = (
  response:
    | StudentsWithoutActiveSubscription[]
    | StudentsWithActiveSubscription[]
    | ParentsWithoutActiveChildSubscription[]
    | ParentsWithActiveChildSubscription[]
): GetSubscriptionReportSuccessAction => {
  return {
    type: GET_SUBSCRIPTION_REPORT_SUCCESS,
    payload: response,
  };
};

export const getSubscriptionReportError = (
  error: any
): GetSubscriptionReportErrorAction => {
  return {
    type: GET_SUBSCRIPTION_REPORT_ERROR,
    payload: error,
  };
};

export const resetSubscriptionReport = (): ResetSubscriptionReportAction => {
  return {
    type: RESET_SUBSCRIPTION_REPORT,
    payload: {},
  };
};

//#endregion
